<template>
  <v-container>
    <v-card>
     <!-- <v-card-title style="color: grey"
                    class="font-weight-black"
      >
        <h3 class="heading font-weight-bold"> ESCRITO {{ currentOrden.tipo == 1 ? 'DEMANDA FAMILIAR' :'PROMOCIÓN' }}<br>
        </h3>
        <v-spacer></v-spacer>
        <v-btn color="#1665ED" dark to="/escritos/show">
          <v-icon>mdi-arrow-left</v-icon>
          Regresar
        </v-btn>
      </v-card-title>-->

      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold"> Contestar {{ formTitle }}</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
        <v-btn color="#0A4A79" dark to="/escritos/show" small class="ml-3">
          <v-icon small class="mr-5">mdi-file</v-icon>
          Ir al Escrito
        </v-btn>
      </v-card-title>
      <v-divider inset></v-divider>
      <v-card-text style="color: grey" class="font-weight-black">
        <v-row  class="mb-n5">
          <v-col cols="12" md="6">
            <div v-if="currentOrden.sala_id < 12">
              <h4 v-if="currentOrden.numero_completo != 0"><span style="color: darkslategrey">NUM. DE TOCA: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE TOCA: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <div  v-if="currentOrden.sala_id == 12">
              <h4 v-if="currentOrden.numero_completo != 0 || currentOrden.sala_id == 12"><span style="color: darkslategrey">NUM. DE ASUNTO: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE ASUNTO: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <span class="font-weight-small  mr-3" style="color: #225882">ESTATUS:</span>
                      <u v-if="currentOrden.status==2" style="color: green">Registrada</u>
                      <u v-if="currentOrden.status==3" style="color: green">Contestada</u><br>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <span class="font-weight-small black--text mr-3">Abogado:</span><u>{{currentOrden.abogado}}</u><br>
            <span class="font-weight-small black--text mr-3">Email:</span><u>{{currentOrden.abogado_email}}</u><br>
            <!-- <span class="font-weight-small black--text mr-3">Secretario:</span><u>{{currentOrden.juez}}</u><br> -->
            <span class="font-weight-small black--text mr-3">Fecha de envío:</span><u>{{currentOrden.created_at | formatDate}}</u><br>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col v-if="currentOrden.tipo == 1" cols="12" md="8" align="left">
              <h3 class="font-weight-bold">Contestación a la presentación de la demanda Familiar</h3>
            </v-col>
            <v-col v-if="currentOrden.tipo == 2" cols="12" md="8" align="left">
              <h3 class="font-weight-bold">Contestación a la presentación de la Promoción</h3>
            </v-col>
            <v-col v-if="currentOrden.tipo == 1 && respuesta == 1" cols="12" md="4" align="left">
              <h3 class="font-weight-bold">Asignar Número de Toca</h3>
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col align="left" cols="12" md="8">
              <v-select
                v-model="respuesta"
                :items="listRespuestas"
                dense
                item-text="respuesta"
                item-value="id"
                label="Selecciona una Respuesta"
                outlined
                persistent-hint
              ></v-select>
            </v-col> -->
            <v-col v-if="currentOrden.tipo == 1 && respuesta == 1" cols="12" md="4">
              <v-text-field
                v-model="expediente"
                dense
                label="Num. Toca"
                outlined
                persistent-hint
                required
                :rules="[v => !!v|| 'Asignar Num de Toca']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                dense
                hide-details="auto"
                name="input-7-1"
                label="Breve descripción de la contestación"
                v-model="descripcion"
                rows="4"
                color="#0A4A79"
                :rules="[v => !!v|| 'Registre una descripción']"
                counter="255"
                maxlength="255"
              ></v-textarea>
            </v-col>
          </v-row>
          </v-form>

          <v-form @submit.prevent="save" ref="evidencia" v-model="validEvidencia" lazy-validation>
          <v-card outlined rounded="lg" elevation="1" class="mt-2">
            <v-card-text class="pb-4">
              <div class="d-flex align-center flex-wrap mb-1">
                <v-icon color="#0A4A79" class="mr-2">mdi-file-certificate-outline</v-icon>
                <span class="font-weight-bold" style="color:#0A4A79; font-size:15px; letter-spacing:0.2px;">Firmar Documento</span>
                <v-spacer></v-spacer>
                <span class="caption grey--text text--darken-1">PDF / DOC • Máx. 20 MB</span>
              </div>
              <v-divider class="mb-4"></v-divider>

              <div class="text-center mb-3">
                <span class="font-weight-medium" style="color:#333;">Acuerdo</span>
              </div>

              <v-file-input
                v-model="file"
                color="#0A4A79"
                label="Seleccionar Acuerdo"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                show-size
                :clearable="false"
                accept="application/pdf, .doc, .docx"
                truncate-length="50"
                hint="Formatos permitidos: PDF, DOC, DOCX"
                persistent-hint
                hide-details="auto"
                class="mb-1"
                :rules="fileRules"
                @change="SelccionarArchivo($event)"
                :disabled="archivo.encode != ''"
              ></v-file-input>

              <v-divider class="my-5"></v-divider>

              <v-row dense>
                <v-col cols="12" md="6">
                  <v-card outlined rounded="lg" class="pa-3 h-100" style="border-color:#E0E0E0;">
                    <div class="d-flex align-center mb-3">
                      <v-avatar size="28" color="#FFF8E1" class="mr-2"><v-icon small color="#F9A825">mdi-certificate-outline</v-icon></v-avatar>
                      <span class="font-weight-bold" style="color:#0A4A79;">Firma Firel</span>
                      <v-spacer></v-spacer>
                      <span class="caption grey--text">.pfx</span>
                    </div>
                    <v-file-input
                      v-model="file_firel"
                      color="#0A4A79"
                      label="Seleccionar archivo .pfx"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      show-size
                      hide-details="auto"
                      hint="Archivo PFX de tu Firel"
                      persistent-hint
                      accept=".pfx"
                      truncate-length="30"
                      @change="SeleccionarPfx($event)"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-file-input>
                    <v-text-field
                      v-model="password"
                      label="Contraseña Firel"
                      placeholder="Ingresa tu contraseña"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="archivo.encode != ''"
                      class="mb-3"
                    ></v-text-field>
                    <div class="d-flex justify-start mt-4" style="margin-left: 32px;">
                      <v-btn
                        small
                        :depressed="!(!activarBoton || (file && file.size && file.size > 20971520))"
                        :outlined="!!(!activarBoton || (file && file.size && file.size > 20971520))"
                        :loading="loadingFirma"
                        :disabled="!activarBoton || (file && file.size && file.size > 20971520)"
                        :color="(!activarBoton || (file && file.size && file.size > 20971520)) ? 'grey' : '#0A4A79'"
                        :dark="!(!activarBoton || (file && file.size && file.size > 20971520))"
                        :class="(!activarBoton || (file && file.size && file.size > 20971520)) ? '' : 'white--text'"
                        class="px-6"
                        style="min-width: 152px;"
                        @click="firmar()"
                      >
                        <v-icon small left :color="(!activarBoton || (file && file.size && file.size > 20971520)) ? '' : 'white'">mdi-draw</v-icon> FIRMAR
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center justify-center">
                  <span class="caption grey--text text--darken-1 text-center">Firma única Firel<br>para contestación</span>
                </v-col>
              </v-row>

              <v-expand-transition>
                <div v-if="archivo.file_name" class="mt-4">
                  <v-alert dense prominent border="left" colored-border color="success" elevation="1" class="mb-0" icon="mdi-check-decagram">
                    <div class="d-flex flex-column flex-sm-row align-stretch align-sm-center justify-space-between" style="gap:12px;">
                      <div class="d-flex flex-column flex-sm-row align-start align-sm-center flex-wrap" style="gap:10px; flex:1 1 auto; min-width:0;">
                        <span class="font-weight-bold d-flex align-center flex-wrap" style="color:#0A4A79; font-size:15px; gap:6px; word-break:break-word; white-space:normal;">
                          <!-- <v-icon small color="success" style="flex-shrink:0;">mdi-check-decagram</v-icon> -->
                          <span style="word-break:break-word;">Contestación Firmada correctamente: </span>
                        </span>
                        <span class="font-weight-medium d-flex align-center flex-wrap" style="color:#1B1B1B; font-size:14.5px; gap:6px; min-width:0; word-break:break-word; overflow-wrap:anywhere;">
                          <img src="@/assets/img/file-pdf.svg" width="26" height="26" style="cursor:pointer; flex-shrink:0;" @click="saveTextAsFile()" alt="PDF" />
                          <span style="word-break:break-all; overflow-wrap:anywhere; min-width:0;">{{ archivo.file_name }}.pdf</span>
                          <v-icon small color="success" style="flex-shrink:0;">mdi-check-circle</v-icon>
                          <v-btn small depressed color="primary" class="flex-shrink-0" style="white-space:nowrap;" @click="saveTextAsFile()">
                            <v-icon small left>mdi-file-eye-outline</v-icon> Ver evidencia
                          </v-btn>
                        </span>
                      </div>
                      <div class="d-flex align-center justify-start justify-sm-end flex-shrink-0 mt-2 mt-sm-0" style="gap:8px;">
                        <!-- <v-btn small outlined color="grey darken-1" @click="cambiarArchivo" style="white-space:nowrap;">
                          <v-icon small left>mdi-refresh</v-icon> Cambiar archivo
                        </v-btn> -->
                      </div>
                    </div>
                  </v-alert>
                </div>
              </v-expand-transition>
            </v-card-text>
          </v-card>
          <div class="mt-4"></div>
          </v-form>

          <!-- <v-row>
            <v-col cols="12" md="5" align="center">
              <h3 class="font-weight-bold">Acuerdo</h3>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col  md="5" align="center">
              <v-file-input
                v-model="file"
                color="blue darken-2"
                label="Seleccionar Acuerdo"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                show-size
                required
                accept="application/pdf"
                truncate-length="50"
                @change="fileSelected()"
                :rules="[v => !!v|| 'Seleccionar un Acuerdo']"
              ></v-file-input>
            </v-col> -->
            <!-- <v-col md="6">
              <v-btn depressed dark color="#0A4A79" @click="">Firmar</v-btn>
            </v-col> -->
          <!-- </v-row>
          <v-row>
            <v-col cols="12" md="5" align="center">
              <h3 class="font-weight-bold">Firmar Documento</h3>
            </v-col>
          </v-row>
          <v-row class="mt-n5 ">
            <v-col md="5">
              <v-file-input
                v-model="key"
                color="blue darken-2"
                label="Ingrese archivo .key"
                prepend-icon="mdi-key"
                outlined
                dense
                accept=""
                truncate-length="50"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col md="5">
              <v-file-input
                v-model="cert"
                color="blue darken-2"
                label="Ingrese archivo .cer"
                prepend-icon="mdi-certificate"
                outlined
                dense
                accept=""
                truncate-length="50"
              ></v-file-input>
            </v-col> -->
            <!-- <v-col class="">
              <v-btn depressed dark color="#0A4A79" @click="fileSelected(file_promocion, 2)">Firmar</v-btn>
            </v-col> -->
          <!-- </v-row> -->
          <!-- <v-row class="mt-n6 ml-5">
            <v-col md="4">
              <v-text-field
                v-model="key"
                prepend-icon="mdi-key"
                dense
                outlined
                class="mb-n4"
                label="Ingrese archivo .key"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n6 ml-5">
            <v-col md="4">
              <v-text-field
                v-model="cert"
                prepend-icon="mdi-certificate"
                dense
                outlined
                class="mb-n4"
                label="Ingrese archivo .cer"
              >
              </v-text-field>
            </v-col>
            <v-col class="">
              <v-btn depressed dark color="#0A4A79" @click="firmarAcuerdo()">Firmar</v-btn>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col cols="12" align="right">
              <v-btn
                v-if="currentOrden.status == 2 && (currentOrden.proceso_multifirma == 0 || currentOrden.sala_id >= 12)"
                depressed
                :color="!valid || !archivo.encode ? 'grey lighten-2' : 'success'"
                :class="!valid || !archivo.encode ? '' : 'white--text'"
                :dark="!!(valid && archivo.encode)"
                :loading="loading"
                :disabled="!valid || !archivo.encode"
                class="px-6"
                style="min-width:160px; font-weight:600; letter-spacing:0.3px;"
                @click="validate"
              >
                <v-icon left :color="!valid || !archivo.encode ? 'grey darken-1' : 'white'">
                  mdi-content-save
                </v-icon>
                Contestar
              </v-btn>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="grey darken-2"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {SelectFileSign,message,SelectPfx,OpenPfx,PKCS7creado,extFileUpload} from '@/services/cliente';
  import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {
        pkcs7:'',
        dialogPdf: false,
        progress: false,
        loading: false,
        valid: true,
        validEvidencia: true,
        showpass: false,
        loadingFirma: false,
        activarBoton: false,
        filePFXselct: false,
        respuesta:'',
        descripcion: '',
        expediente: '',
        currentOrden:'',
        key:[],
        cert:[],
        files:[],
        file:[],
        file_firel: [],
        url_contestacion:'',
        nombre_contestacion:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        archivoDefault:{
          encode:'',
          type:'',
          file_name:''
        },
        sign:true,
        user:'',
        password:'',
        listRespuestas: [
          { id: 1, respuesta: 'Admitida' },
          { id: 2, respuesta: 'No Admitida'},
        ],
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB',
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      formTitle () {
        if (this.currentOrden.sala_id === 12) {
          return 'Asunto Laboral'
        }else if (this.currentOrden.sala_id === 13) {
          return 'Buzón Presidencia'
        }
        return 'Promoción'
      },
      ...mapGetters(["currentUser"]),
    },
    mounted() {
    this.currentOrden =  JSON.parse(localStorage.getItem("currentOrden"))
    },
    methods:{
      //Metodos Firel
      SelccionarArchivo(file) {
       
       if(file === null){
           this.activarBoton = false;
          return false;  
        }

        SelectFileSign(file).then((isValidFile)=>{
            if(isValidFile){
                this.message=message;
                this.extArchivoCargado=extFileUpload;
            }

            if(this.filePFXselct != ""){
                   this.activarBoton = true;
                }
         });
      },
      SeleccionarPfx(filePFX) {

        if(filePFX === null){
          this.filePFXselct = '';
          this.activarBoton =false;
          return false;
        }
        this.filePFXselct=filePFX;
        this.activarBoton=SelectPfx(filePFX);
        // if(this.activarBoton){
        //     this.filePFXselct=filePFX;
        // }
      },
      firmar() {
        OpenPfx(this.filePFXselct,this.password).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                // console.log(PKCS7creado);
                this.creaEvidencia(this.pkcs7);
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Archivo PFX o contraseña invalida, Favor de Verificar',
                confirmButtonText: "Aceptar",
                // timer: 1500,
              })
            }
         });
      },
      creaEvidencia(pkcs7)
      {
        Swal.fire({
          title: 'Estableciendo comunicación',
          html: 'Generando Evidencia Criptográfica ...',
          // timer: 5000,
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        this.creaevidencia=true;
        // this.progress = true;
        this.loadingFirma = true;
        // console.log("hola mundo");
        // let archivos = this.pkcs7.nativeElement.files;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest }).then(response => {
             Swal.close();
             console.log(response.data);
             // this.progress = false
             this.loadingFirma = false;
             this.loadingeFirma = false;
             if(!response.data.data.IsSuccess){
                    Swal.fire({
                     icon: 'error',
                     title: response.data.data.ErrorMessage,
                     confirmButtonText: "Aceptar",
                    //  timer: 4500,
                   })
                return false;
               }
               
             Swal.fire({
               icon: 'success',
               title: 'Contestación Firmada con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
             this.archivo.encode = response.data.data.PdfBase64;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
             console.log(this.archivo);
             // this.key = [];
             // this.cert = [];
             this.file_firel = [];
             this.file = [];
             this.password = '';
             this.activarBoton = false;
             this.$refs.evidencia.resetValidation()
           })
           .catch(err => {
             console.log(err);
             this.progress = true
             this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },
      // cambiarArchivo(){
      //   this.archivo = Object.assign({}, this.archivoDefault);
      //   this.file = [];
      //   this.file_firel = [];
      //   this.password = '';
      //   this.activarBoton = false;
      //   this.filePFXselct = false;
      //   if(this.$refs.evidencia) this.$refs.evidencia.resetValidation();
      // },
      validate() {
        if (this.$refs.form.validate()) {
          // if (this.file == "") {
          //   Swal.fire({
          //     icon: 'warning',
          //     title: 'Selecciona un Acuerdo',
          //     confirmButtonText: "Aceptar",
          //   })
          //   this.loading = false
          // } else
          if(this.archivo.encode == ''){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Firmar Acuerdo',
              confirmButtonText: "Aceptar",
            })
          } else
          if (this.sign == true) {
            this.loading = true
            if(this.currentOrden.sala_id == 12){
              this.url_contestacion = "/expediente/"+this.currentOrden.id+"/contestacion"
              this.nombre_contestacion = 'Expediente_Laboral'
            } else if(this.currentOrden.sala_id == 13) {
              this.url_contestacion = "/buzon/"+this.currentOrden.id+"/contestacion"
              this.nombre_contestacion = 'Escrito_Buzon'
            } else {
              this.url_contestacion = "/promocion/"+this.currentOrden.id+"/contestacion"
              this.nombre_contestacion = 'Acuerdo_Promocion'
            }
            this.save()
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },
      firmarAcuerdo(){
          // var url = "https://e-firma.stjjalisco.gob.mx/(S(sgj2pok3qcijclcysys53xjy))/Home/InicioSesion"
          // window.open(url, '_blank');
        this.sign = true;
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Promoción Firmada',
        //   timer: 1500,
        // })
      },
      save() {
        // this.FilesToUpload()
        const data = {
          contestacion: this.respuesta,
          texto: this.descripcion,
          file: this.archivo,
          nombre: this.nombre_contestacion
        }
        if (this.expediente != '') {
          data.carpeta_investigacion =this.expediente
        }
        if (this.currentOrden.tipo == 2) {
          data.nombre = 'Acuerdo_Promocion'
        }
        // console.log(data);
        this.$store.dispatch("SAVE_CONTESTACION",  { url: this.url_contestacion, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Contestación Enviada',
            timer: 1500,
          })
          this.loading = false
          // this.close();
          this.$router.push('/panel')
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },

      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      // saveExpediente() {
      //   // this.FilesToUpload()
      //   const data = {
      //     contestacion: this.respuesta,
      //     texto: this.descripcion,
      //     file: this.archivo,
      //     nombre: 'Expediente_Laboral'
      //   }
      //   if (this.expediente != '') {
      //     data.carpeta_investigacion =this.expediente
      //   }
      //   // if (this.currentOrden.tipo == 2) {
      //   //   data.nombre = 'Acuerdo_Promocion'
      //   // }
      //   // console.log(data);
      //   this.$store.dispatch("SAVE_CONTESTACION_EXPEDIENTE",  { url: "/expediente/"+this.currentOrden.id+"/contestacion", data: data })
      //   .then(response => {
      //     Swal.fire({
      //       icon: 'success',
      //       title: 'Contestación Enviada',
      //       timer: 1500,
      //     })
      //     this.loading = false
      //     // this.close();
      //     this.$router.push('/panel')
      //   })
      //     .catch(error => {
      //       this.loading = false
      //       console.log(error);
      //       Swal.fire({
      //         icon: 'error',
      //         title: 'Error',
      //         text: error.response.data.message,
      //         confirmButtonText: "Aceptar"
      //       });
      //       // this.close();
      //     });
      // },
      // saveBuzon() {
      //   // this.FilesToUpload()
      //   const data = {
      //     contestacion: this.respuesta,
      //     texto: this.descripcion,
      //     file: this.archivo,
      //     nombre: 'Buzon_Presidencia'
      //   }
      //   if (this.expediente != '') {
      //     data.carpeta_investigacion =this.expediente
      //   }
      //   // if (this.currentOrden.tipo == 2) {
      //   //   data.nombre = 'Acuerdo_Promocion'
      //   // }
      //   // console.log(data);
      //   this.$store.dispatch("SAVE_CONTESTACION_PRESIDENCIA",  { url: "/buzon/"+this.currentOrden.id+"/contestacion", data: data })
      //   .then(response => {
      //     Swal.fire({
      //       icon: 'success',
      //       title: 'Contestación Enviada',
      //       timer: 1500,
      //     })
      //     this.loading = false
      //     // this.close();
      //     this.$router.push('/panel')
      //   })
      //     .catch(error => {
      //       this.loading = false
      //       console.log(error);
      //       Swal.fire({
      //         icon: 'error',
      //         title: 'Error',
      //         text: error.response.data.message,
      //         confirmButtonText: "Aceptar"
      //       });
      //       // this.close();
      //     });
      // },
      fileSelected(){
        var file = this.file;
        this.getBase64(file).then(data => {
          this.files.push(data);
          // console.log(this.files);
          this.firmarAcuerdo()
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['file_name'] = this.file.name.split(".pdf")[0];
            // console.log(this.archivo.file_name);
          });
        }
      },

      close () {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.archivo = Object.assign({}, this.archivoDefault)
        this.respuesta = ''
        this.descripcion = ''
        this.expediente = ''
        this.files = []
        this.file = []
      },

    }
  }
</script>
